import React from 'react';
// Constants
import { CompanyAddress, CompanyName } from '../../utils/Constants';
// Images
import BuildingImage from '../../assets/images/backgrounds/the-tavistock-inn-hotel-building.jpg';
import BarOutline from '../../assets/images/outlines/ale-pumps-outline-sketch-white.png';
import Image1 from '../../assets/images/main/the-tavistock-hotel-and-inn-food-03054.webp';
import Image2 from '../../assets/images/food/tavy-inn-food-7-1200.webp';
import Image3 from '../../assets/images/building/the-tavistock-inn-hotel-and-food-7.webp';

const AboutComponent = () => {
  return (
    <section
      id='about'
      className='grid w-full bg-colour1 text-white border-b-2 border-t-2 border-solid border-colour2'
    >
      <div className='grid w-full bg-colour1 text-white px-6 py-10 lg:min-h-screen'>
        {/* Phone screen */}
        <section className='grid text-center lg:hidden'>
          <section className='grid lg:w-2/3 lg:mx-auto'>
            <div>
              <h3 className='font-GaramondBold text-4xl md:text-5xl font-bold mb-6'>
                Come and enjoy
              </h3>
            </div>
            <div>
              <p className='text-lg md:text-xl leading-relaxed mb-8'>
                <span className='font-semibold'>{CompanyName}</span> is a
                traditional British pub offering a warm atmosphere, delicious
                food, and a wide selection of beers and ales.
              </p>
            </div>
            <div>
              <p className='text-text-colour font-semibold text-xl'>
                {CompanyAddress}
              </p>
            </div>
            <div>
              <img
                src={BarOutline}
                alt=''
                className='max-w-56 lg:max-w-80 mx-auto mt-2'
                loading='lazy'
              />
            </div>
          </section>

          <section className='grid lg:grid-cols-2 lg:mx-auto lg:gap-4 pt-8'>
            {/* Image Section */}
            <div className='py-12 lg:py-0 grid lg:items-center lg:order-last'>
              <div className='grid p-2 bg-white'>
                <img
                  src={BuildingImage}
                  alt='Front of The Tavistock Inn on Brook Street, Tavistock'
                  className='w-full mx-auto rounded-lg max-h-[400px] shadow-lg'
                  loading='lazy'
                />
              </div>
            </div>

            {/* Description Section */}
            <div className='lg:order-first grid lg:items-center lg:px-10'>
              <p className='lg:text-left'>
                Nestled in the heart of Tavistock, Devon, The Tavistock Inn is a
                quintessential British pub and hotel. Renowned for its warm
                hospitality, it offers a rich selection of locally brewed ales,
                crisp lagers, and hearty traditional pub fare. Whether you're in
                the mood for a cozy meal, a lively evening of music, or a
                competitive poker night, The Tavistock Inn has something for
                everyone. Furry friends are welcome too, making it a perfect
                spot for dog lovers. With its blend of historic charm and modern
                comforts, The Tavistock Inn promises an authentic pub experience
                that locals and visitors alike cherish.
              </p>
            </div>
          </section>

          <div className='pt-8'>
            <a href='#map' className='text-lg underline underline-offset-4'>
              Find Us On Map
            </a>
          </div>
        </section>

        {/* Large screen */}
        <section className='hidden lg:grid grid-cols-[1fr_minmax(300px,_0.6fr)] w-full h-full'>
          {/* Content Section */}
          <section className='grid relative w-full h-full justify-center items-center border-r-2 border-solid border-colour2'>
            <div className='grid z-10 w-3/4 mx-auto'>
              <section className='grid mx-auto'>
                <div>
                  <h3 className='text-6xl font-GaramondBold font-bold mb-6'>
                    Come and enjoy
                  </h3>
                </div>
                <div>
                  <p className='text-xl leading-relaxed mb-8'>
                    <span className='font-semibold'>{CompanyName}</span> is a
                    traditional British pub offering a warm atmosphere,
                    delicious food, and a wide selection of beers and ales.
                  </p>
                </div>
                <div className='pb-4'>
                  <p className='text-text-colour font-semibold text-xl'>
                    {CompanyAddress}
                  </p>
                </div>
              </section>
              {/* Description Section */}
              <section>
                <div className='grid '>
                  <p className=''>
                    Nestled in the heart of Tavistock, Devon, The Tavistock Inn
                    is a quintessential British pub and hotel. Renowned for its
                    warm hospitality, it offers a rich selection of locally
                    brewed ales, crisp lagers, and hearty traditional pub fare.
                    Whether you're in the mood for a cozy meal, a lively evening
                    of music, or a competitive poker night, The Tavistock Inn
                    has something for everyone. Furry friends are welcome too,
                    making it a perfect spot for dog lovers. With its blend of
                    historic charm and modern comforts, The Tavistock Inn
                    promises an authentic pub experience that locals and
                    visitors alike cherish.
                  </p>
                </div>
                <div className='pt-8'>
                  <a
                    href='#map'
                    className='text-lg underline underline-offset-4'
                  >
                    Find Us On Map
                  </a>
                </div>
              </section>
            </div>

            <img
              src={BarOutline}
              alt=''
              className='absolute w-72 xl:w-80 bottom-4 right-4'
              loading='lazy'
            />
          </section>

          {/* Background Image Section with additional images */}
          <section
            style={{
              backgroundImage: `url(${BuildingImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
            className='grid h-full w-full bg-cover bg-center filter contrast-125 sature-150'
          >
            <div className='grid grid-cols-3 absolute bottom-0 w-full border-t-2 border-solid border-colour2'>
              <img
                src={Image1}
                alt='Scampi and seasoned chips basket meal with tartare sauce'
                className='w-full h-40 object-cover'
                loading='lazy'
              />
              <img
                src={Image2}
                alt='Scrambled eggs and grilled tomato breakfast'
                className='w-full h-40 object-cover'
                loading='lazy'
              />
              <img
                src={Image3}
                alt='Cosy pub interior with log burner and booth seating'
                className='w-full h-40 object-cover'
                loading='lazy'
              />
            </div>
          </section>
        </section>
      </div>
    </section>
  );
};

export default AboutComponent;
